import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('userEmailManagementStore')
@observer
class UserEmailManagement extends Component {
  render() {
    const { userEmailManagementStore } = this.props
    const { isFetching } = userEmailManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default UserEmailManagement;
